import { ApiBase } from '../ApiBase';
class MetaConversionsApiClientModel extends ApiBase {
    constructor() {
        super(...arguments);
        this.getPixel = () => {
            return this.get('/meta-conversions/pixel');
        };
        this.setPixel = (pixelId, accessToken) => {
            return this.put('/meta-conversions/pixel', {
                pixelId,
                accessToken,
            });
        };
        this.deletePixel = () => {
            return this.delete('/meta-conversions/pixel');
        };
    }
}
export const MetaConversionsApiClient = new MetaConversionsApiClientModel();
